import * as React from 'react';
import styled from 'styled-components';
import Layout from '../components/Layout';
import headerRightBg from '../images/sales-funnel/headerRightBg.png';
import headerRightBg375 from '../images/sales-funnel/headerRightBg375.png';
import WomanLaptopCouch from '../images/sales-funnel/WomanLaptopCouch.svg';
import EmailContactSales from '../components/EmailContactSales';
import ProblemSolution from '../components/ProblemSolution';
import FeaturesAndBenefits from '../components/FeaturesAndBenefits';
import Testimonial from '../components/Testimonial';
import JeffreyNiesen from '../images/sales-funnel/JeffreyNiesen.jpg';
import BankersBankWhiteLogo from '../images/sales-funnel/BankersBankWhiteLogo.png';
import Marketplace from '../images/sales-funnel/Marketplace.svg';
import Phone from '../images/sales-funnel/Phone.svg';
import Tags from '../images/sales-funnel/Tags.svg';
import FinancialInstitutions from '../components/FinancialInstitutions';
import halfSectionGradient from '../images/sales-funnel/halfSectionGradient.png';
import fullWidthSplitBg from '../images/sales-funnel/fullWidthSplitBg.png';
import TwoPhonesLeafs from '../images/sales-funnel/TwoPhonesLeafs.png';
import WantToSeeHow from '../components/WantToSeeHow';

const HeaderContent = styled.article`
	padding-bottom: 1em;
	display: flex;
	flex-direction: column;

	& h1 {
		min-height: 0;
	}

	& p {
		max-width: 490px;
	}
`;

const indexHeaderContent =
	<HeaderContent style={{marginTop: `0`, paddingTop: `75px`}}>
		<h1>SalesFunnel</h1>
		<p>Online shopping experiences<br />for loan products</p>
		<EmailContactSales />
	</HeaderContent>
;

const HeaderBottomContentFigure = styled.figure`

	& svg.bottomAligned {
		max-width: 90%;
		margin-top: 3em;
		margin-bottom: 3em;

		@media (${(props) => props.theme.mediumUp}) {
			max-width: 100%;
			margin-top: 0;
			margin-bottom: 0;
		}

		@media (${(props) => props.theme.largeUp}) {
			max-width: 459px;
		}

		@media (${(props) => props.theme.xLargeUp}) {
			max-width: 100%;
		}
	}
`;

const WomanLaptopCouchFigure =
	<HeaderBottomContentFigure>
		<WomanLaptopCouch alt='Woman with Laptop' className='bottomAligned' />
	</HeaderBottomContentFigure>
;

const Section = styled.section`

	&.full-width-split#SalesFunnelSplit {

		@media (${(props) => props.theme.mediumUp}) {
			& .responsivePadding {
				align-items: stretch;

				& article.right-on-desktop {
					align-items: center;
					display: flex;
				}
			}
		}

		& figure {
			background-color: #3498D3;
			background-image: ${(props) => `url('${halfSectionGradient}')`};
			align-items: center;

			@media (${(props) => props.theme.mediumUp}) {
				padding-right: 30px;
			}

			@media (${(props) => props.theme.largeUp}) {
				padding-right: 40px;
			}

			/* IE11 */

			@media all and (-ms-high-contrast: none) {
				& img {
					max-width: 340px;
					max-height: 312px;
				}
			}

			@media (${(props) => props.theme.smallUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 530px;
					max-height: 486px;
				}
			}

			@media (${(props) => props.theme.mediumUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 295px;
					max-height: 271px;
				}
			}

			@media (${(props) => props.theme.largeUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 390px;
					max-height: 356px;
				}
			}

			@media (${(props) => props.theme.xLargeUp}) and (-ms-high-contrast: none) {
				& img {
					max-width: 502px;
					max-height: 462px;
				}
			}
		}
	}

	@media (${(props) => props.theme.mediumUp}) {
		&.blueLeftWhiteRight {
			background-image: ${(props) => `url('${fullWidthSplitBg}')`};
		}
	}
`;

const SalesFunnelPage = (props: any) => {
	return (
	<Layout
		headerSplashBg={headerRightBg}
		headerSplashBg375={headerRightBg375}
		headerSplashBgSize={'100% 100%'}
		headerSplashBgSizeLarge={'auto'}
		headerSplashBgPosition={'right top'}
		headerSplashBgPositionLarge={'center top'}
		headerSplashAlignItemsLarge={'flex-end'}
		headerBottomContent={WomanLaptopCouchFigure}
		headerContentClass={'product'}
		headerContent={indexHeaderContent}
		headerContentMaxWidth={'490px'}
		headerSplashBgAverageColor={'white'}
		pageTitle='SalesFunnel - Financial product marketplace'
		metaDescription={'Build brand recognition and increase customer acquisition with our simple, beautiful marketing pages that educate your customers on your financial products.'}
		skipMoney2020={true}
		splashHeaderMinHeight={'410px'}
		BodyClass={'SalesFunnel'}
	>
		<ProblemSolution
			problem={'Financial institutions have minimal content to help educate their customers when shopping for financial products online.'}
			solution={'SalesFunnel’s modern marketing interfaces educate and inform customers, helping them make confident decisions about financial products.'}
		/>
		<Testimonial
			portrait={JeffreyNiesen}
			portraitAlt={'Jeffrey Niesen'}
			name={'Jeffrey Niesen'}
			title={'Senior Vice President,'}
			company={"Bankers' Bank"}
			quote={'As we have seen, many borrowers gravitate toward institutions with online applications. MK has been a great partner in developing a streamlined, mobile-first credit decisioning solution.'}
			logo={BankersBankWhiteLogo}
			logoAlt={"Bankers' Bank of Wisconsin logo"}
		/>
		<FeaturesAndBenefits
			solidBgColor = {'#3498d3'}

			leftIcon = {<Marketplace alt='credit card store front icon' style={{margin: `0`}} />}
			leftHeading = {'Financial product\nmarketplace'}
			leftText={'Increase revenue by helping customers choose financial products.'}

			middleIcon = {<Phone alt='smartphone icon' style={{margin: `3px 0`}} />}
			middleHeading = {'Mobile-first\ninterface'}
			middleText = {'Provide convenient shopping experiences from any device.'}

			rightIcon = {<Tags alt='white labels icon' style={{margin: `8px 0`}} />}
			rightHeading = {'White label\nsolution'}
			rightText = {'Build brand loyalty by maintaining a consistent web presence.'}
		/>
		<Section className='full-width-split full-width blueLeftWhiteRight' id='SalesFunnelSplit'>
			<div className='centeredWrapper'>
				<div className='responsivePadding row row-flush'>
					<article className='col-12 col-md-6 right-on-desktop'>
						<div className='product text-box'>
							<header>
								<h2>Stand out from the crowd</h2>
							</header>
							<p>Continue your bank's digital transformation. Provide simple, beautiful customer experiences that increase confidence when choosing your financial products — but loyalty must be earned.</p><p>So, educate customers when they're shopping online with transparent, mobile-first marketing pages. Make your trusted brand stand out from the crowd with a consistent digital presence that will increase your bottom line.</p>
						</div>
					</article>
					<figure className='col-12 col-md-6 left-on-desktop'>
						<img src={TwoPhonesLeafs} alt='screenshots of two smartphones with MK web apps' />
					</figure>
				</div>
			</div>
		</Section>
		<div className='centeredWrapper'>
			<FinancialInstitutions />
			<WantToSeeHow />
		</div>
	</Layout>
	);
};

export default SalesFunnelPage;
